var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39844 1.03125C4.36087 1.03125 1.89844 3.49368 1.89844 6.53125C1.89844 9.56882 4.36087 12.0312 7.39844 12.0312C10.436 12.0312 12.8984 9.56882 12.8984 6.53125C12.8984 3.49368 10.436 1.03125 7.39844 1.03125ZM0.898438 6.53125C0.898438 2.9414 3.80859 0.03125 7.39844 0.03125C10.9883 0.03125 13.8984 2.9414 13.8984 6.53125C13.8984 10.1211 10.9883 13.0312 7.39844 13.0312C3.80859 13.0312 0.898438 10.1211 0.898438 6.53125ZM6.73177 3.53125C6.73177 3.16306 7.03025 2.86458 7.39844 2.86458C7.76663 2.86458 8.0651 3.16306 8.0651 3.53125C8.0651 3.89944 7.76663 4.19792 7.39844 4.19792C7.03025 4.19792 6.73177 3.89944 6.73177 3.53125ZM7.89844 9.86458V5.19792H6.89844V9.86458H7.89844Z",
    fill: "#3E3E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInfoIcon);
export default __webpack_public_path__ + "static/media/file-info-icon.9da7666940e32f9f965356f3d46bc060.svg";
export { ForwardRef as ReactComponent };